import { EnumTotemType } from '@/pages/StoreManagement/states';

export interface ResponseLockPaginate {
    meta: Meta;
    data: ResponseLock[];
}

export interface Meta {
    total: number;
    per_page: number;
    current_page: number;
    last_page: number;
    first_page: number;
    first_page_url: string;
    last_page_url: string;
    next_page_url: any;
    previous_page_url: any;
}

export interface ResponseLock {
    id: number;
    lock_id: number;
    user_id: number;
    sale_id: any;
    store_id: number;
    open_method: string;
    created_at: string;
    updated_at: string;
    opened_at: string;
    totem_sale_id: any;
    sale: any;
    lock: Lock;
    store: Store;
    user: UserLock;
}

export interface Lock {
    id: number;
    qrcode: string;
    status: number;
    is_for_legal_age: number;
    store_id: number;
    created_at: string;
    updated_at: string;
    nickname?: string;
}

export interface Store {
    id: number;
    shopmanager_id: number;
    address_id: number;
    name: string;
    category: string;
    logo: string;
    latitude: number;
    longitude: number;
    is_open: number;
    description: string;
    type: any;
    phone: string;
    inventory: string;
    created_at: string;
    updated_at: string;
    qr_code: any;
    active: number;
    is_qr_code_required: number;
    fraud_prevention_id: number;
    store_business_type: any;
    store_business_quantity: any;
    hide_zero_stock: number;
    active_pwa: number;
    active_app: number;
    allow_purchases_stock_less_than_quantity: number;
    automatic_refund: number;
    automatic_refund_value: number;
    view_only_app: number;
    only_nearest_store: number;
    minimum_distance: number;
    demand_facial_biometrics_unlock_port: any;
    can_emit_invoice: number;
    emit_invoice: number;
}

export interface UserLock {
    id: number;
    email: string;
    is_confirmed: number;
    created_at: string;
    updated_at: string;
    iugu_id: any;
    pagarme_id: string;
    is_default_payment_id: string;
    provider_google: string;
    provider_apple: string;
    provider_facebook: string;
    notification_token: string;
    last_device_id: string;
    last_app_version: string;
    last_platform: string;
    client: ClientLock;
}

export interface ClientLock {
    id: number;
    user_id: number;
    is_validated_cpf: number;
    is_blocked: boolean;
    name: string;
    cpf: string;
    date_birth: string;
    phone: string;
    created_at: string;
    updated_at: string;
    profile_image: any;
    provider_id: string;
    provider: string;
    permission_local: number;
    permission_camera: number;
}

export type InventoryType =
    | 'store-physical'
    | 'warehouse-physical'
    | 'virtual'
    | 'null';

export enum StoreListOrderBy {
    first_sale = 'firstSale',
    last_sale = 'lastSale',
    sum_total_one_month_ago = 'salesLastMonth',
}

export enum StoreListOrderDir {
    ascend = 'asc',
    descend = 'desc',
}
export interface ParamsStoreManagement {
    page?: number;
    perPage?: number;
    name?: string;
    shopmanagerId?: number;
    storeId?: number;
    shopmanagerEmail?: string;
    isTotemAuthenticated?: boolean | null;
    totemEnum?: EnumTotemType;
    city?: string;
    state?: string;
    totem?: boolean;
    active?: boolean;
    open?: boolean;
    inventory?: InventoryType[];
    firstSaleDate?: string;
    saleInLastSevenDays?: boolean | string;
    orderBy?: StoreListOrderBy;
    orderDir?: StoreListOrderDir;
}
